import styled from '@emotion/styled';
import type { FieldProps, TextInputProps } from '@hover/blueprint';
import { Field, TextInput, forwardRef, useMergeRefs } from '@hover/blueprint';
import type { IconProp } from '@hover/icons';
import type { ReactElement } from 'react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

interface TextFieldProps
  extends Omit<FieldProps, 'children'>,
    Pick<TextInputProps, 'iconBefore' | 'placeholder' | 'type'> {
  iconBefore?: IconProp;
  elementAfter?: ReactElement;
  showFormFieldErrors?: boolean;
}

const ElementAfterWrapper = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
`;

const OnboardingTextField = forwardRef<TextFieldProps, 'input'>(
  (
    {
      iconBefore,
      elementAfter,
      name,
      placeholder,
      type,
      showFormFieldErrors = true,
      ...props
    },
    ref,
  ) => {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { errors, register } = useFormContext<Record<string, string>>();
    const refs = useMergeRefs(ref, register);
    const error = errors[name]?.message;
    return (
      <Field
        {...props}
        error={showFormFieldErrors ? error : ''}
        label={placeholder}
        name={name}
        pb={0}
      >
        <TextInput
          elementAfter={
            elementAfter && (
              <ElementAfterWrapper>{elementAfter}</ElementAfterWrapper>
            )
          }
          iconBefore={iconBefore}
          placeholder=""
          ref={refs}
          size="default"
          type={type}
        />
      </Field>
    );
  },
);

export { OnboardingTextField };
